import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { BlogList } from "@/components/admin/blog/BlogList";

export const Route = createFileRoute("/_authenticated/admin/blog/")({
  head: () => ({
    meta: [
      { title: "Админ — Блог | FIXHEN" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <AdminLayout>
      <BlogList />
    </AdminLayout>
  ),
});